module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 57300.ad3c5938.png";